import React from "react";

function Orthodontics() {
  return <div>Orthodontics</div>;
}

export default Orthodontics;
